import React from "react";
import { LightGradientBackground } from "components/hero";
import { TextTitle, type TextTitleProps } from "ui/text";
import Image from "next/image";
import { AspectRatio } from "@chakra-ui/react";
import teamPhoto from "../../../public/assets/company/about/team-photo.png";

export function AboutHero({ title, description }: Pick<TextTitleProps, "title" | "description">) {
  return (
    <LightGradientBackground variant="yellow" pb={{ base: "big", md: "huge" }}>
      <TextTitle
        size="xl"
        align="center"
        mobileAlign="center"
        title={title}
        description={description}
        maxW="2xl"
        mt={{ base: "biggest", md: "huge" }}
        mb={{ base: "bigger", md: "biggest" }}
      />

      <AspectRatio
        ratio={{ base: 1000 / 600, sm: 2 / 1, md: 1320 / 600 }}
        borderRadius={{ base: "small", md: "bigger" }}
        overflow="hidden"
        w="100%"
      >
        <Image fill src={teamPhoto} alt="A group photo of all the Hightouch team members." />
      </AspectRatio>
    </LightGradientBackground>
  );
}
